import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1de3f42d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-panorama container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "main-title" }, "3D-тур – предоставляем к каждому объекту", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "project-panorama__annotation" }, " Изучите наш проект в деталях: перемещайтесь по пространству, рассматривайте материалы и планировку. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_View360 = _resolveComponent("View360")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_View360, {
      class: "is-2by1",
      projection: _ctx.projection,
      "initial-yaw": 0,
      initialZoom: 0,
      autoplay: true,
      wheelScrollable: true,
      rotate: { disablePitch: true }
    }, null, 8, ["projection"])
  ]))
}